import { FC, useContext, useEffect, useRef, useState } from 'react';

import {
  BottomIcon,
  Button,
  CirclesIcon,
  TopIcon,
  WorkerIcon,
} from '@smartshell/ui-kit';
import dayjs from 'dayjs';

import { FeaturesContext } from 'features';

import { Controls } from './Controls';
import { CurrentOperator } from './CurrentOperator';
import { Me } from './Me';
import { Subscription } from './Subscription';
import { ThemeSwitcher } from './ThemeSwitcher';
import s from './UserMenu.module.scss';

export const UserMenu: FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { expiresAt } = useContext(FeaturesContext);

  const isExpiring = expiresAt && dayjs(expiresAt).diff(dayjs(), 'days') <= 14;
  const menuRef = useRef<HTMLDivElement>(null);
  const openerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isVisible) return;

    const handleMouseDown = (e: MouseEvent): void => {
      const target = e.target as Node;
      const modalRoot = document.getElementById('modal-root');
      const onboarding = document.querySelector(
        '[data-testid="sandbox-onboarding"]'
      );
      if (
        menuRef.current?.contains(target) ||
        openerRef.current?.contains(target) ||
        modalRoot?.contains(target) ||
        onboarding?.contains(target)
      ) {
        return;
      }

      setIsVisible(false);
    };

    const handleEsc = (e: KeyboardEvent): void => {
      if (e.key === 'Escape') {
        setIsVisible(false);
      }
    };

    document.addEventListener('mousedown', handleMouseDown);
    document.addEventListener('keydown', handleEsc);

    return () => {
      document.removeEventListener('mousedown', handleMouseDown);
      document.removeEventListener('keydown', handleEsc);
    };
  }, [isVisible]);

  return (
    <div className={s.container}>
      <div ref={openerRef} data-onboarding="user-menu">
        <Button
          className={s.opener}
          variant="ghost"
          aria-label="Меню сотрудника"
          onClick={() => {
            setIsVisible((prev) => !prev);
          }}
        >
          <WorkerIcon size="m" />
          {isVisible ? <TopIcon /> : <BottomIcon />}
          {isExpiring && <CirclesIcon className={s.attention} />}
        </Button>
      </div>

      {isVisible && (
        <div ref={menuRef} className={s.menu}>
          <Me />
          <CurrentOperator />
          {isExpiring && <Subscription />}
          <ThemeSwitcher />
          <Controls />
        </div>
      )}
    </div>
  );
};
